const AlertActionTypes = {
    START_ERROR_ALERT_DISPLAY: 'START_ERROR_ALERT_DISPLAY',
    FINISH_ERROR_ALERT_DISPLAY: 'FINISH_ERROR_ALERT_DISPLAY',

    START_SUCCESS_ALERT_DISPLAY: 'START_SUCCESS_ALERT_DISPLAY',
    FINISH_SUCCESS_ALERT_DISPLAY: 'FINISH_SUCCESS_ALERT_DISPLAY',

    START_INFO_ALERT_DISPLAY: 'START_INFO_ALERT_DISPLAY',
    FINISH_INFO_ALERT_DISPLAY: 'FINISH_INFO_ALERT_DISPLAY',

    START_WARNING_ALERT_DISPLAY: 'START_WARNING_ALERT_DISPLAY',
    FINISH_WARNING_ALERT_DISPLAY: 'FINISH_WARNING_ALERT_DISPLAY',

    FETCH_NOTIFICATION_ALERT_DISPLAY: 'FETCH_NOTIFICATION_ALERT_DISPLAY',
    START_NOTIFICATION_ALERT_DISPLAY: 'START_NOTIFICATION_ALERT_DISPLAY',
    FINISH_NOTIFICATION_ALERT_DISPLAY: 'FINISH_NOTIFICATION_ALERT_DISPLAY',

    START_FETCH_APP_NOTIFICATIONS: 'START_FETCH_APP_NOTIFICATIONS',
    SUCCESS_FETCH_APP_NOTIFICATIONS: 'SUCCESS_FETCH_APP_NOTIFICATIONS',
    FINISH_FETCH_APP_NOTIFICATIONS: 'FINISH_FETCH_APP_NOTIFICATIONS',
    FAILURE_FETCH_APP_NOTIFICATIONS: 'FAILURE_FETCH_APP_NOTIFICATIONS',

    START_DELETE_APP_NOTIFICATION: 'START_DELETE_APP_NOTIFICATION',
    SUCCESS_DELETE_APP_NOTIFICATION: 'SUCCESS_DELETE_APP_NOTIFICATION',
    FAILURE_DELETE_APP_NOTIFICATION: 'FAILURE_DELETE_APP_NOTIFICATION',
}

export default AlertActionTypes
